module.exports = __webpack_public_path__ + "9f561edcb47d52e6cf197f83c83761f7.png";